<script>
import InvoiceService from "@/services/InvoiceService";

export default {
    props: {
        invoiceId: {}
    },
    data() {
        return {
            loading: true,
            invoice: null,
            saving: false
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                const { data } = await InvoiceService.GET_germanInvoice(
                    this.invoiceId
                );
                this.invoice = data.data;
            } catch (e) {
                console.log("err", e);
            }

            this.loading = false;
        },
        download(mark = false) {
            const link = document.createElement("a");
            link.href = `/v1/invoices/project-pdf-invoice/${this.invoiceId}`;
            link.download = `invoice.pdf`;
            link.click();
        },
        async downloadAndMark() {
            this.saving = true; 
            await InvoiceService.PUT_markAsInvoiced(this.invoiceId);
            this.saving = false; 
            this.download(true);
            this.$emit("update");
            this.$emit("close");
        }
    }
};
</script>

<template>
    <modal
        size="xl"
        :show="true"
        :showClose="true"
        :loading="loading"
        class="invoice-show-modal"
        @close="$emit('close')"
    >
        <template slot="header">
            {{ $t("invoice.mark_as_invoiced_and_download_pdf") }}
        </template>

        <template slot="default">
            <div class="text-center">
                <base-button size="lg" type="primary" @click="download"
                    ><i class="far fa-file-pdf fa-fw fa-lg"></i>
                    {{ $t("invoice.download_invoice_pdf") }}</base-button
                >

                <base-button @click="downloadAndMark" size="lg" type="primary" :loading="saving"
                    ><i class="far fa-file-pdf fa-fw fa-lg"></i>
                    {{
                        $t("invoice.download_invoice_pdf_and_mark_as_invoiced")
                    }}</base-button
                >
            </div>
        </template>
    </modal>
</template>
